import { $ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-article-footer]')) return;

  dataLayerArticleFooter();
}

function dataLayerArticleFooter() {
  $('[data-au-article-footer-author]').addEventListener('click', (e) => {
    e.preventDefault();
    const el = e.currentTarget;
    const titleText = el.closest('[data-au-article]').querySelector('[data-au-title]')
      ? el.closest('[data-au-article]').querySelector('[data-au-title]').innerText
      : '';
    const clickText = el.innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id,
    });
  });
}

export default { init };
